import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungOsnabrueck() {
  return (
    <CityPageTemplate
      city="Osnabrück"
      slug="osnabrueck"
      intro="Osnabrück als Stadt des Westfälischen Friedens – Deine Finanzen verdienen genauso viel Stabilität."
      description="Unabhängige & digitale Finanzberatung für Osnabrück: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
